import classNames from "classnames";
import React, { useRef } from "react";
import { WrappedFieldProps as FieldProps } from "redux-form";
import scrollIntoView from "scroll-into-view-if-needed";

import useEffectOnMount from "seneca-common/utils/hooks/useEffectOnMount";

import "./FormArea.scss";

type Props = {
  label: string;
  subLabel?: HTMLSpanElement;
  placeHolder?: string;
  wrapperClass?: string;
  textAreaClass?: string;
  pulse?: boolean;
  autoFocus?: boolean;
};

export default function FormArea(props: Props & FieldProps) {
  const {
    label,
    subLabel,
    placeHolder,
    wrapperClass,
    textAreaClass,
    pulse,
    input,
    meta,
    autoFocus,
    ...otherProps
  } = props;
  const error = meta.error && meta.submitFailed;
  const inputClassName = classNames({
    FormArea__input: true,
    "FormArea__input--error": error,
    "FormArea__input--pulseError": error && pulse
  });

  const inputRef = useRef<HTMLInputElement>();

  useEffectOnMount(() => {
    if (autoFocus && inputRef.current && inputRef.current.focus) {
      inputRef.current.focus({
        preventScroll: true
      });
      scrollIntoView(inputRef.current, {
        block: "start",
        behavior: "smooth",
        scrollMode: "if-needed",
        boundary: document.body
      });
    }
  });

  return (
    <div className={`FormArea ${wrapperClass ? wrapperClass : ""}`}>
      {(label || subLabel) && (
        <label className="FormArea__label" htmlFor={input.name}>
          {label}
          {!!subLabel && <div>{subLabel}</div>}
        </label>
      )}
      <textarea
        // @ts-ignore
        ref={inputRef}
        {...otherProps}
        {...input}
        className={`${inputClassName} ${textAreaClass || ""}`}
        placeholder={placeHolder}
      />
      {error && <p className="FormArea__error">{meta.error}</p>}
    </div>
  );
}
